<template>
  <font-awesome-icon :icon="iconClass" />
</template>

<script>
export default {
  props: {
    icon: {
      type: [String, Array],
      required: true,
    },
  },
  data() {
    return {
      defaultIconFamily: 'fas',
      definedIcons: new Map([
        ['edit', ['fal', 'edit']],
        ['delete', ['fal', 'trash-alt']],
        ['expand', ['fad', 'plus-square']],
        ['shrink', ['fad', 'minus-square']],
        ['consult', ['fas', 'file-alt']],
        ['complete', ['fas', 'check']],
        ['info', ['fas', 'info-circle']],
        ['checked', ['far', 'check-circle']],
        ['unchecked', ['far', 'circle']],
        ['pdf', ['far', 'file-pdf']],
      ]),
    }
  },

  computed: {
    iconClass() {
      if (Array.isArray(this.icon)) {
        return this.icon
      } else if (this.definedIcons.has(this.icon)) {
        return this.definedIcons.get(this.icon)
      }
      return [this.defaultIconFamily, this.icon]
    },
  },
}
</script>
